(function () {
  'use strict';

  function initVideo(video) {
    if (video.dataset.nextdevIwtVideoInit) return;
    video.dataset.nextdevIwtVideoInit = '1';

    // look up from the section, not from the video's parent: a theme is free
    // to wrap a video in something of its own
    var scope = video.closest
      ? (video.closest('[data-nextdev-iwt]') || video.parentElement)
      : video.parentElement;
    var playBtn = scope ? scope.querySelector('[data-nextdev-iwt-play]') : null;
    var muteBtn = scope ? scope.querySelector('[data-nextdev-iwt-mute]') : null;
    var progress = scope ? scope.querySelector('[data-nextdev-iwt-progress]') : null;

    // says the script reached this section, so a theme that never served it
    // can be told apart from a section that is behaving badly
    if (scope && scope.hasAttribute('data-nextdev-iwt')) {
      scope.setAttribute('data-nextdev-iwt', 'ready');
    }

    var inView = false;

    // iOS needs these set as properties, not only as attributes
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;

    function showPlayButton() {
      if (playBtn) playBtn.classList.add('nextdev--image-with-text__play--visible');
    }
    function hidePlayButton() {
      if (playBtn) playBtn.classList.remove('nextdev--image-with-text__play--visible');
    }

    // nothing starts the video while it is off screen, whatever asked
    function tryPlay() {
      if (!inView) return;
      var p = video.play();
      // play() returns a Promise in modern browsers, undefined in older ones
      if (p && typeof p.then === 'function') {
        p.then(hidePlayButton).catch(function () {
          // iOS Low Power Mode and Data Saver block autoplay, so offer a button
          showPlayButton();
        });
      }
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i += 1) {
          inView = entries[i].isIntersecting;
          if (inView) {
            tryPlay();
          } else if (entries[i].boundingClientRect.height > 0) {
            // a section the theme has not laid out yet reports no box at all,
            // and that is not the same as having left the screen
            video.pause();
          }
        }
      }, { threshold: 0.25 });
      io.observe(video);
    } else {
      inView = true;
      tryPlay();
    }

    if (playBtn) {
      playBtn.addEventListener('click', function () {
        video.muted = true;
        if (muteBtn) muteBtn.setAttribute('aria-pressed', 'true');
        // asked for by hand, on a button that is only on screen when the
        // video is, so it does not go through the in-view guard
        var p = video.play();
        if (p && typeof p.then === 'function') {
          p.then(hidePlayButton).catch(showPlayButton);
        } else {
          hidePlayButton();
        }
      });
    }

    // the line across the top, in place of the browser's own controls
    function mark() {
      if (!progress) return;
      var along = video.duration ? video.currentTime / video.duration : 0;
      progress.style.setProperty('--nextdev-iwt-progress', (along * 100).toFixed(2) + '%');
      progress.classList.toggle('nextdev--image-with-text__progress--on', along > 0 || !video.paused);
    }
    video.addEventListener('timeupdate', mark);
    video.addEventListener('play', mark);
    video.addEventListener('loadedmetadata', mark);

    // the sound starts off, because that is the only way a video autoplays
    if (muteBtn) {
      muteBtn.addEventListener('click', function () {
        video.muted = !video.muted;
        muteBtn.setAttribute('aria-pressed', video.muted ? 'true' : 'false');
        muteBtn.setAttribute('aria-label', video.muted ? 'Turn the sound on' : 'Turn the sound off');
        // unmuting counts as a gesture, so a video the browser held back starts
        if (!video.muted && video.paused) tryPlay();
      });
      video.addEventListener('volumechange', function () {
        muteBtn.setAttribute('aria-pressed', video.muted ? 'true' : 'false');
      });
    }

    // the first touch on the page unlocks playback on iOS, and tryPlay still
    // refuses if the video is nowhere near the screen
    var unlock = function () {
      tryPlay();
      document.removeEventListener('touchstart', unlock);
      document.removeEventListener('click', unlock);
    };
    document.addEventListener('touchstart', unlock, { once: true, passive: true });
    document.addEventListener('click', unlock, { once: true });
  }

  // ---- a button with no link of its own ----
  // On a product page a button left without a link takes the visitor to the
  // choice they still have to make. Everything is looked up when it is
  // pressed, not when the page loads, so the section finds what the page it
  // sits on has, on any template and in any order:
  //   - from 1024 up, the page scrolls back to the size and colour picker in
  //     the product info section;
  //   - under 1024, the sticky add to cart opens its panel of options over
  //     the page, so the choice is made without leaving the spot. The bar has
  //     to be up for that, which it is once the product's own add to cart has
  //     gone up past the top. Where it is not, or the template has no bar,
  //     the page scrolls to the picker the way it does on a wide screen;
  //   - a product with nothing to choose has no picker drawn, so the page
  //     scrolls to the top of the product info section instead, at any width.
  // Off a product page there is nothing to find and the button does nothing.
  // A button with a link is a plain <a> and never comes through here.

  // the split the sticky add to cart uses, where its options stop being a
  // panel and sit in the row
  var WIDE = '(min-width: 1024px)';

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  // What is stuck over the top of the screen, the sale line in the header
  // group, so what is scrolled to lands under it rather than behind it.
  // Measured at the press, because the line can be switched off or change
  // height with the width.
  function stuckHeight() {
    var h = 0;
    var els = document.querySelectorAll('.shopify-section-group-header-group');
    for (var i = 0; i < els.length; i += 1) {
      var cs = window.getComputedStyle(els[i]);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') continue;
      var r = els[i].getBoundingClientRect();
      if (!r.height) continue;
      h = Math.max(h, r.height + (parseFloat(cs.top) || 0));
    }
    return h;
  }

  function scrollToEl(el) {
    var top = el.getBoundingClientRect().top + window.pageYOffset - stuckHeight() - 16;
    window.scrollTo({ top: Math.max(0, top), behavior: reducedMotion() ? 'auto' : 'smooth' });
  }

  // a picker that is in the page but not drawn, display none at some width,
  // has no place to scroll to
  function drawn(el) {
    return !!(el && el.getClientRects().length);
  }

  // The sticky add to cart moves itself to the end of <body> and marks
  // which section it came from, so it is found by that mark; a bar its
  // script has not reached yet is still inside the section.
  function stickyBar(pdp) {
    var wrap = pdp.closest('[id^="shopify-section-"]');
    var bar = wrap
      ? document.querySelector('[data-nextdev-sticky-atc][data-nextdev-sticky-atc-for="' + wrap.id + '"]')
      : null;
    return bar || pdp.querySelector('[data-nextdev-sticky-atc]');
  }

  function toOptions() {
    var pdp = document.querySelector('[data-nextdev-pdp]');
    if (!pdp) return;

    var picker = pdp.querySelector('[data-nextdev-atc-target]');
    if (!drawn(picker)) {
      scrollToEl(pdp);
      return;
    }

    var narrow = window.matchMedia ? !window.matchMedia(WIDE).matches : false;
    if (narrow) {
      var bar = stickyBar(pdp);
      if (bar && typeof bar.nextdevStickyAtcOpen === 'function' && bar.nextdevStickyAtcOpen()) return;
    }

    scrollToEl(picker);
  }

  function initButton(btn) {
    if (btn.dataset.nextdevIwtScrollInit) return;
    btn.dataset.nextdevIwtScrollInit = '1';
    btn.addEventListener('click', toOptions);
  }

  function init() {
    var videos = document.querySelectorAll('[data-nextdev-iwt-video]');
    for (var i = 0; i < videos.length; i += 1) initVideo(videos[i]);
    var buttons = document.querySelectorAll('[data-nextdev-iwt] [data-nextdev-scroll-to-options]');
    for (var j = 0; j < buttons.length; j += 1) initButton(buttons[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // the theme editor swaps the section out and back in
  document.addEventListener('shopify:section:load', function () {
    init();
  });
})();